
/**
 * @fileOverview dynamicDropdownValues module definition
 * Last Modified: 7/01/2014

 * Future Enhancements: 
add various variable combinations,
Try using linebreak as delimeter,
tired using but \n break adds the 
slashes(\) to the data-options
key and value. Below is the output example  
HTML data-options Settings: "{\"dropDownValues\" : \"BirthYear\ncats\ndogs\nlion\"}"
Need to investigate more
 */

(function (context) {
    'use strict';
    var require = context.require,
		requirejs = context.requirejs,
		define = context.define;

    define('views/DynamicDropdownValues',['require','jquery','lib/Util','polyfills/indexOf'],function(require) {
        var $ = require('jquery'),
			Util = require('lib/Util'),
			indexOf = require('polyfills/indexOf');

        $debug('DynamicDropdownValues loaded... use ?debug=dynamicDropdownValues for messages');

        /**
         * This retrieves the dynamic value for select box
         *
         * @class DynamicDropdownValues
         * @param {jQuery} $element A reference to the containing DOM element
         * @constructor
         */
        var DynamicDropdownValues = function ($element) {
            /**
             * A reference to the containing DOM element
             *
             * @default null
             * @property $element
             * @type {jQuery}
             * @public
             */
            this.$element = $($element);

            /**
             * Tracks whether component is enabled.
             *
             * @default false
             * @property isEnabled
             * @type {bool}
             * @public
             */
            this.isEnabled = false;

            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         * Exits early if it is already initialized
         *
         * @method init
         * @returns {DynamicDropdownValues}
         * @private
         */
        DynamicDropdownValues.prototype.init = function() {
            this.setOptions()
                .createChildren()
                .build();

            return this;
        };

		/**
		 * This sets the options via data-options in the html markup. If
		 * the options aren't set it goes to the defaults.
		 * Syntax for HTML should be data-options='{"enabled" : false, "dropDownValues" : "apple|melon|usps$$postal|%BirthYear%"}'
		 *
		 * @method setOptions
		 * @returns {DynamicDropdownValues}
		 * @private
		 */
		DynamicDropdownValues.prototype.setOptions = function () {
			var options = this.$element.data().options;
			
            var defaults = {
				enabled : true,
				dropDownValues : undefined
			};
	
			this.settings = $.extend({}, defaults, options);    //merge defaults with data-options object
			$debug('\n\n******** dynamicDropdownValues Options **********', 'dynamicDropdownValues');
			$debug('     HTML data-options Settings: ' + $printObj(options),'dynamicDropdownValues');
			$debug('     Default Settings: ' + $printObj(defaults),'dynamicDropdownValues');
			$debug('     Combined Settings: ' + $printObj(this.settings),'dynamicDropdownValues');
			return this;
		};

        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @method createChildren
         * @returns {DynamicDropdownValues}
         * @private
         */
        DynamicDropdownValues.prototype.createChildren = function() {
            $debug('*** In createChildren ***', 'dynamicDropdownValues');
            return this;
        };

        /**
         * Remove any child objects or references to DOM elements
         *
         * @method removeChildren
         * @returns {DynamicDropdownValues}
         * @public
         */
        DynamicDropdownValues.prototype.removeChildren = function() {

            return this;
        };

        /**
         * Get the dynamic values keyword and add to the selectbox
         * TO DO create various combination of variables, eg - states, year variation etc
         * @method build
         * @returns {DynamicDropdownValues}
         * @public
         */
        DynamicDropdownValues.prototype.build = function() {
            $debug('*** In build ***', 'dynamicDropdownValues');
            var self = this,
				enabled = self.settings.enabled,
				arrVal = '%BirthYear%',
				keyValSeperator = '$$',
				ddValues = self.settings.dropDownValues,
				ddVal = [],
				splitVal = [],
				newDate = new Date(),
				year = newDate.getFullYear(),
                i;

            ddVal = ddValues.split('|');

			$debug('this is ddVal after split ' +ddVal, 'dynamicDropdownValues');
				
			if (ddVal.length !== -1) {
				$.each(ddVal, function(key, value) {
					$debug('Adding all options key: ' + key +' value: ' + value, 'dynamicDropdownValues');

					self.$element.append($('<option />)').val(value).html(value));
					
					//Check for BirthYear, condition show 1915 till current Year for rU-04-subscribe
					if(value.indexOf(arrVal) !== -1){
						for (i = year; i > 1914; i--){
							self.$element.append($('<option />').val(i).html(i));
							self.$element.sort(function(a, b){
                                return b-a;
                            });
							self.$element.children('option[value="%BirthYear%"]').remove();
						}
					}

					if(value.indexOf(keyValSeperator) !== -1){ //$.isin Array
						splitVal = value.split(keyValSeperator);
						$debug('splitVal VALUE: ' + splitVal, 'dynamicDropdownValues');
						
						self.$element.append($('<option></option>').attr('value',splitVal[1]).text(splitVal[0]));
						self.$element.children('option[value="'+ value +'"]').remove();
					}
				});
			}
						
			return this;
        };
		
        return DynamicDropdownValues;
    });

}(MMMRequire));

